import { languageService } from "../services";

// STATE
const state = {
  items: [],
  loading: false
};

// ACTIONS
const actions = {
  // get all available languages
  GET_LANGUAGES({ dispatch, commit }) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      languageService.getAll().then(
        langs => {
          commit("requestSuccess", langs);
          resolve(true);
        },
        error => {
          commit("requestFail");
          reject(error);
        }
      );
    });
  }
};

// MUTATIONS
const mutations = {
  requestSent(state) {
    state.loading = true;
  },
  requestSuccess(state, collection) {
    state.loading = false;
    state.items = collection;
  },
  requestFail(state) {
    state.loading = false;
    state.items = [];
  }
};

// GETTERS
const getters = {};

// EXPORT
export const language = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
